import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {VendSizeFlavorXrefEditComponent} from '../../components/DomainDataEdit/VendSizeFlavorXrefEdit.component';

//base
import { BaseDomainDataGridComponent }         from '../../baseclasses/BaseDomainDataGrid';

@Component({
  selector: 'my-vendsizeflavorxref-grid',
  templateUrl: './VendSizeFlavorXrefGrid.component.html'
})
export class VendSizeFlavorXrefGridComponent extends BaseDomainDataGridComponent {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(VendSizeFlavorXrefEditComponent) recordEditComponent: VendSizeFlavorXrefEditComponent;

    userInfo: ent.UserInfo;
    records: ent.VendSizeFlavorXref[];
    selectedRecords: ent.VendSizeFlavorXref[] = [];
    editedRecord: ent.VendSizeFlavorXref;

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService,
         private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        
        this.userInfo = this.authenticationService.getUserInfo();
        this.editedRecord = new ent.VendSizeFlavorXref();
        this.recordEditComponent.vendSizeDropdown.load();
        this.recordEditComponent.flavorDropdown.load();
        this.onSearchClick(null);
    }

    onSearchClick(event: any){
        this.domainDataService.getVendSizeFlavorXrefs({IncludeInactive: true}).subscribe(x=>{this.records = x});
    }

    onAddClick(event: any){
        this.editedRecord = new ent.VendSizeFlavorXref();
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, vendSizeFlavorXref: ent.VendSizeFlavorXref){
        this.editedRecord = vendSizeFlavorXref;
        this.recordEditComponent.flavorDropdown.value = vendSizeFlavorXref.FlavorID;
        this.recordEditComponent.vendSizeDropdown.value = vendSizeFlavorXref.VendSizeID;
        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SaveVendSizeFlavorXrefRequest = {VendSizeFlavorXref: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.domainDataService.saveVendSizeFlavorXref(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }


}